import { render, staticRenderFns } from "./PendingBanner.vue?vue&type=template&id=7a74de74&scoped=true"
import script from "./PendingBanner.vue?vue&type=script&lang=js"
export * from "./PendingBanner.vue?vue&type=script&lang=js"
import style0 from "./PendingBanner.vue?vue&type=style&index=0&id=7a74de74&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a74de74",
  null
  
)

export default component.exports